import { render } from "./DetailTab.vue?vue&type=template&id=0c8876b3&ts=true"
import script from "./DetailTab.vue?vue&type=script&lang=ts"
export * from "./DetailTab.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__